import type { Input } from 'valibot';
import { 
  boolean, 
  maxLength, 
  minLength, 
  number, 
  object, 
  optional, 
  string
} from 'valibot';

// データベースから取得される基本的なcompany_memberオブジェクト
export const companyMemberDBObject = object({
  id: string(),
  user_id: string(),
  name: string([
    minLength(1, "メンバー名は必須です"),
    maxLength(100, "メンバー名は100文字以内で入力してください")
  ]),
  position: optional(string([
    maxLength(100, "役職は100文字以内で入力してください")
  ])),
  profile_image_url: optional(
    string([maxLength(500, "画像パスが長すぎます")])
  ),
  bio: optional(string([
    maxLength(1000, "自己紹介は1000文字以内で入力してください")
  ])),
  display_order: number(),
  is_public: boolean(),
  created_at: string(),
  updated_at: string(),
});

// 会社メンバー作成時の入力スキーマ
export const companyMemberCreateSchema = object({
  user_id: string(),
  name: string([
    minLength(1, "メンバー名は必須です"),
    maxLength(100, "メンバー名は100文字以内で入力してください")
  ]),
  position: optional(string([
    maxLength(100, "役職は100文字以内で入力してください")
  ])),
  profile_image_url: optional(
    string([maxLength(500, "画像パスが長すぎます")])
  ),
  bio: optional(string([
    maxLength(1000, "自己紹介は1000文字以内で入力してください")
  ])),
  display_order: optional(number()),
  is_public: optional(boolean()),
});

// 会社メンバー更新時の入力スキーマ
export const companyMemberUpdateSchema = object({
  name: optional(string([
    minLength(1, "メンバー名は必須です"),
    maxLength(100, "メンバー名は100文字以内で入力してください")
  ])),
  position: optional(string([
    maxLength(100, "役職は100文字以内で入力してください")
  ])),
  profile_image_url: optional(
    string([maxLength(500, "画像パスが長すぎます")])
  ),
  bio: optional(string([
    maxLength(1000, "自己紹介は1000文字以内で入力してください")
  ])),
  display_order: optional(number()),
  is_public: optional(boolean()),
});

// 公開用のcompany_memberスキーマ（公開フラグがtrueのもののみ）
export const companyMemberPublicSchema = companyMemberDBObject;

// TypeScript型定義
export type CompanyMemberDB = Input<typeof companyMemberDBObject>;
export type CompanyMemberCreate = Input<typeof companyMemberCreateSchema>;
export type CompanyMemberUpdate = Input<typeof companyMemberUpdateSchema>;
export type CompanyMemberPublic = Input<typeof companyMemberPublicSchema>;